import React, { FC, useRef, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Icon } from '@iconify/react'
import useOutsideClick from '@app/hooks/useOutsideClick'
import S from './Faq.styles'

interface QuestionProps {
  question: string
  answer: string
}

const Question: FC<QuestionProps> = ({ question, answer }) => {
  const node = useRef<HTMLLIElement>(null)
  const [expand, setExpand] = useState(false)

  useOutsideClick(node, () => setExpand(false))

  return (
    <S.Question ref={node} className={expand ? 'open' : 'closed'}>
      <button type="button" onClick={() => setExpand(!expand)}>
        <span>{question}</span>
        <Icon icon="mdi-light:chevron-down" fontSize={32} />
      </button>
      {expand && (
        <S.Answer>
          <ReactMarkdown>{answer}</ReactMarkdown>
        </S.Answer>
      )}
    </S.Question>
  )
}

export default Question
